module.exports = __webpack_public_path__ + "img/contact-jonathanolsson.2110c812.png";